.bq{flex-shrink:0;}